export function getCurrencySymbol(currency) {
  let map = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
  };

  return map[currency] || currency;
}

export default {
  getCurrencySymbol
}



// WEBPACK FOOTER //
// ./src/logic/helpers/CurrencyHelper.js